<template>
    <div class="box">
        <div class="box-left" ref="boxLeft">
            <my-form
                v-model="form"
                autocomplete="off"
                label-width="80px"
                @submit="submitHandler"
            >
                <el-form-item
                    label="计费额"
                    prop="costlimit"
                    :rules="newRule('计费额', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.costlimit"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入计费额`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="设置行业"
                    prop="industryratio"
                    :rules="newRule('行业', 'required')"
                >
                    <el-select
                        v-model="form.industryratio"
                        @change="industryratioHandler"
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.industryid"
                            :label="item.industryname"
                            :value="item.industryid"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <span class="coefficient">行业调整系数:{{ form.ratio }}</span>

                <el-form-item
                    label="工作内容"
                    prop="work"
                    :rules="newRule('工作内容', 'required')"
                >
                    <el-select
                        v-model="form.work"
                        @change="workHandler"
                        multiple
                        collapse-tags
                        clearable
                        placeholder="请选择"
                        class="select"
                    >
                        <el-option
                            v-for="item in workArr"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 效益收费 -->
                <el-form-item
                    label="施工阶段"
                    v-if="isShow('arr10')"
                    prop="construction"
                    :rules="newRule('施工阶段', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.construction"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入施工阶段`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="结算效益"
                    v-if="isShow('arr12')"
                    prop="settlement"
                    :rules="newRule('结算效益', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.settlement"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入结算效益`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>
                <span v-if="isShow('arr12')" class="coefficient">结算效益基数(审增金额+审减金额)</span>


              <el-form-item
                    label="全过程效益基数"
                    v-if="isShow('arr14')"
                    prop="process"
                    :rules="newRule('全过程效益基数', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.process"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入全过程效益基数`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>
                <span v-if="isShow('arr14')" class="coefficient">全过程效益基数基数(审增金额+审减金额)</span>

                <el-form-item
                    label="折扣"
                    prop="discount"
                    :rules="newRule('折扣', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.discount"
                        @change="discountHandler"
                        clearable
                        type="number"
                        min="0"
                        autocomplete="off"
                        :placeholder="`请输入折扣`"
                    >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>

                <template slot="btn" slot-scope="scope">
                    <div class="btn-login">
                      <el-button
                        type="primary"
                        @click="scope.submitHandler"
                      >
                        开始计算
                      </el-button>
                    </div>
                </template>
            </my-form>
        </div>

        <div class="box-right">
            <el-table
                class="table-res"
                :data="tableData"
                border
                style="width: 100%"
                :max-height="tableMaxHeight"
            >
                <el-table-column prop="name" label="工作内容" width="120">
                </el-table-column>
                <el-table-column
                    prop="calculate"
                    label="收费标准：万元"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        {{ scope.row.calculate || "0" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="calculate2"
                    label="折扣后收费：万元"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        {{ scope.row.calculate2 || "0" }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                costlimit: "", //估价
                industryratio: "", //行业
                ratio: "", //系数
                discount: 100, //折扣
                work: [], //工作内容
                construction: "", //施工阶段
                settlement: "", //结算效益
                process: "", //全过程效益基数
            },

            tableMaxHeight: "289", //表格最大高度

            options: [], //行业数组
            workArr: [], //工作数组

            tableData: [
                {
                    name: "总计",
                    calculate: "",
                    calculate2: "",
                },
            ],
        };
    },
    computed:{
      costMoney(){
        return ''
      }
    },
    methods: {
        submitHandler() {
            var workString = "";
            // 将多选数组转字符串,并用 . 拼接
            workString = this.form.work.toString().replace(/,/g, ".");
            console.log(workString);
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getCalculateData.json`,
                {
                    costlimit: this.form.costlimit,
                    industryratio: this.form.ratio,
                    discount: this.form.discount,
                    strings: workString,
                    benefit1: this.form.construction,
                    benefit2: this.form.settlement,
                    benefit3: this.form.process,
                    type: "TYPE6",
                },
                (data) => {
                    this.tableData = data.list;
                }
            );
            this.$emit('startCompute');
        },
        /**
         * 折扣输入框 change 事件
         */
        discountHandler() {
            if (this.form.discount < 0) {
                this.form.discount = 0;
            }
          let discountStr = String(this.form.discount)
          discountStr = discountStr.replace(/[^\d.]/g, "")
            .replace(/^0\d+|^\./g, "")
            .replace(/\.{2,}/g, ".")
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
          this.form.discount = parseFloat(discountStr) || 0;
        },
        /**
         * 工作内容选择框 change 事件
         */
        workHandler(val) {
            // （施工阶段、结算效益、全过程效益基数）id数组
            var arr = ["arr10", "arr12", "arr14"];
            // （施工阶段、结算效益、全过程效益基数）存在个数
            var num = 0;
            for (let i = 0; i < this.form.work.length; i++) {
                if (arr.includes(this.form.work[i])) {
                    num++;
                }
            }
            // 根据（施工阶段、结算效益、全过程效益基数）存在个数变更表格最大高度
            if (num == 0) {
                this.tableMaxHeight = "289";
            } else if (num == 1) {
                this.tableMaxHeight = "337";
            } else if (num == 2) {
                this.tableMaxHeight = "385";
            } else if (num == 3) {
                this.tableMaxHeight = "433";
            }
            // 不展示的时候清空所输入内容
            var res1 = this.isShow("arr10");
            if (!res1 && this.form.construction) {
                this.form.construction = "";
            }
            var res2 = this.isShow("arr12");
            if (!res2 && this.form.settlement) {
                this.form.settlement = "";
            }
            var res3 = this.isShow("arr14");
            if (!res3 && this.form.process) {
                this.form.process = "";
            }
            // 根据选择工作内容更新表格
            var workString = "";
            // 将多选数组转字符串,并用 . 拼接
            workString = this.form.work.toString().replace(/,/g, ".");
            if (this.form.work.length > 0) {
                this.$get(
                    // /bbs/navigation/showResultFormat.json
                    `${this.$store.state.api.webUrl}/navigation/showResultFormat.json`,
                    {
                        concat: workString,
                    },
                    (data) => {
                        this.tableData = data.result;
                    }
                );
            } else {
                this.tableData = [
                    { name: "总计", calculate: "", calculate2: "" },
                ];
            }

            // let filterArr = this.workArr.filter((item) => {
            //     return val.includes(item.id);
            // });
            // this.tableData = filterArr
        },
        /**
         * 行业选择框 change 事件
         */
        industryratioHandler() {
            const that = this;
            that.form.ratio = that.options.filter(function (val) {
                return val.industryid == that.form.industryratio;
            })[0].ratio;
        },

        /**
         * 获取数据
         */
        queryData() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getManufacturecostAll.json`,
                (data) => {
                    this.options = data.select1;
                    this.workArr = data.select2;
                    this.form.industryratio = data.select1[0].industryid;
                    this.form.ratio = data.select1[0].ratio;
                }
            );
        },
        /**
         * 效益收费是否展示 (施工阶段、结算效益、全过程效益基数)
         */
        isShow(id) {
            var res = this.form.work.includes(id);
            return res;
        },

        /**
         * 测试跳转
         */
        testJump() {
            window.open(`http://www.baidu.com?${this.form.costlimit}`);
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
@import '../style/main.scss';

.box {
    width: 100%;
    box-sizing: border-box;
    .coefficient {
        display: block;
        margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 24px;
        color: #606266;
    }
    .select {
        width: 100%;
    }

    .btn-login {
      display: flex;
      justify-content: center;
    }
}
.box > div {
    float: left;
    width: 400px;
}

.box-right {
    width: 520px !important;
    margin-top: -55px;
    margin-left: 100px;
}
</style>
